import { lullabySlice } from "./reducer";

export const {
  deleteLullaby,
  replaceLullabies,
  saveLullaby,
  setDefaultLullaby,
  setLullabiesLibrary
} = lullabySlice.actions;
